@if (isLoaded()) {
  <div [class.row]="isList()" role="list" [attr.aria-label]="'fgbcl.accessibility.marketplace.list' | translate">
    @if (showStatusFilter()) {
      <div class="mb-3">
        <fgbcl-filter-status-modal
          [filterTypesList]="filterTypesList()"
          (filterTypesListEmitter)="handleFilterTypesListEmitter($event)"
          [selectedValues]="selectedState()"
          (selectedValuesEmitter)="handleSelectedStateEmitter($event)"
        ></fgbcl-filter-status-modal>
      </div>
    }
    @if (filteredMarketplaceItems()?.length > 0) {
      <ng-container *fgbWebsiteContentFeatureFlag="'fgbcl.feature.flag.marketplace.sortbar'">
        <fgbcl-sort-bar
          class="row w-100"
          [sortBarOptions]="sortBarOptions"
          [itemList]="filteredMarketplaceItems()"
          [displayDefaultSort]="true"
          (defaultSortAction)="setDefaultSort()"
        ></fgbcl-sort-bar>
      </ng-container>
      @for (item of filteredMarketplaceItems(); track item.Id) {
        <div role="listitem" [class.col-lg-4]="isList()" [class.col-6]="isList()">
          <div class="loyalty-item-container">
            <fgbcl-marketplace-list-item-v2
              [marketplaceItem]="item"
              [featuredIcon]="featuredIcon()"
            ></fgbcl-marketplace-list-item-v2>
          </div>
        </div>
      }
    } @else {
      <!-- No results -->
      <div class="rewards-placholder" role="status" aria-live="polite">
        <ng-container *ngIf="marketplaceItemView() || eventItemView() || productsItemView()">
          <div class="no-items no-results-placeholder-div">
            <div
              class="svg svg-info vs-svg ms-auto me-auto"
              fgbAnimateSvg
              [inlineSVG]="
                marketplaceItemView()
                  ? 'assets/images/placeholders/Marketplace.svg'
                  : eventItemView()
                    ? 'assets/images/placeholders/Events.svg'
                    : 'assets/images/placeholders/Marketplace.svg'
              "
            ></div>

            <div class="no-results-placeholder">
              {{
                marketplaceItemView()
                  ? ('marketplace.placeholder.description' | translate)
                  : eventItemView()
                    ? ('events.placeholder.description' | translate)
                    : ('products.placeholder.description' | translate)
              }}
            </div>
          </div>
        </ng-container>
      </div>
    }
  </div>
} @else {
  <div class="w-100">
    <fgbcl-loading></fgbcl-loading>
  </div>
}
